<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Status das Solicitações</h1>
    <div class="mb-2 mt-3 d-flex" style="gap: 12px">
      <SGPFormSelectComponent 
        :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados" :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
        :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
        :optionSelecione="'Não'" @change="filtrarDeletados($event)"
      />
    </div>
    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

      <SGPTabelaAvancadaComponent
        v-if="listaDeCtrlStatus && listaDeCtrlStatus.length"
        :colunas="colunas"
        :dados="listaDeCtrlStatus"
        :key="JSON.stringify(listaDeCtrlStatus)"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
        selecionarColunas
      >
      </SGPTabelaAvancadaComponent>
    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Status das Solicitações"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCtrlStatusComponent
        :tipoFormulario="tipoFormulario"
        :ctrlStatus="ctrlStatus"
        @fechar="fecharModal"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingCtrlStatus"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlStatusComponent from '../components/FormularioCtrlStatusComponent.vue'

export default {
  components: { FormularioCtrlStatusComponent },
  name: 'CtrlStatusPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      linhasSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      ctrlStatus: {},
      opcoesSelect: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      exibirItensDeletados: ''
    }
  },
  created () {
    this.listarCtrlStatus();
  },
  computed: {
    ...mapGetters('ctrlStatus', ['listaDeCtrlStatus','loadingCtrlStatus']),

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'status', label: 'Status', sortable: true },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlStatus', 
    [
      'listarCtrlStatus',
      'excluirCtrlStatus',
      "restaurarCtrlStatus"
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.linhasSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.ctrlStatus = this.linhasSelecionadas[0];
      this.abrirModal = true;
    },

    async restaurarSelecionado(item){
      await this.restaurarCtrlStatus(item.id);
      await this.listarCtrlStatus(this.montarPayload());
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    async confirmarDelecao () {
      await this.excluirCtrlStatus(this.linhasSelecionadas);
      this.deletarDados = false;
      await this.listarCtrlStatus(this.montarPayload());
    },

    adicionarNovo () {
      this.ctrlStatus = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    filtrarDeletados(event) {
      if(typeof event == 'undefined'){
          return false;
      }

      this.listarCtrlStatus(this.montarPayload());
    },

    aplicarFiltros() {
      this.listarCtrlStatus(this.montarPayload());
    },

    montarPayload() {
      return {
          trashed: this.exibirItensDeletados
        }
    }
  }
}
</script>
